import * as React from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { setFieldsState } from '../../../actions/fieldsState';
import { FormField } from '../../../components/FormField';
import { PriceInput } from '../../../components/PriceInput';
import { selectRentPrice } from '../../../selectors/rentPrice';
import { TThunkDispatch } from '../../../types/redux/thunk';

export const RentPrice: React.FC = () => {
  const dispatch = useDispatch<TThunkDispatch>();
  const rentPrice = useSelector(selectRentPrice);

  const handleChange = React.useCallback(
    (value: number | null) => {
      dispatch(setFieldsState({ rentPrice: value }));
    },
    [dispatch],
  );

  return (
    <FormField label="Сколько в месяц тратите на аренду?" data-name="RentPriceFormField">
      <PriceInput value={rentPrice} onChange={handleChange} />
    </FormField>
  );
};
